import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';
import { formatDateLong } from 'platform/utilities/date';
import { getMedicalCenterNameByID } from 'platform/utilities/medical-centers/medical-centers';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import content from '../../../../locales/en/content.json';
import { selectHealthEnrollmentStatus } from '../../../../selectors';

const NULL_STATUSES = new Set([
  HEALTH_ENROLLMENT_STATUSES.deceased,
  HEALTH_ENROLLMENT_STATUSES.nonMilitary,
]);

const WarningStatus = () => {
  const { parsedStatus, applicationDate, enrollmentDate, preferredFacility } =
    useSelector(selectHealthEnrollmentStatus);

  const facilityName = useMemo(
    () => getMedicalCenterNameByID(preferredFacility),
    [preferredFacility],
  );

  const formattedDates = useMemo(
    () => ({
      applicationDate: applicationDate && formatDateLong(applicationDate),
      enrollmentDate: enrollmentDate && formatDateLong(enrollmentDate),
    }),
    [applicationDate, enrollmentDate],
  );

  const hasNullStatus = useMemo(
    () => NULL_STATUSES.has(parsedStatus),
    [parsedStatus],
  );

  const showEnrolledDetails =
    parsedStatus === HEALTH_ENROLLMENT_STATUSES.enrolled;

  const hasValueToRender = useMemo(
    () =>
      formattedDates.applicationDate ||
      formattedDates.enrollmentDate ||
      facilityName,
    [facilityName, formattedDates],
  );

  if (!hasValueToRender || hasNullStatus) return null;

  return (
    <ul className="no-bullets">
      {formattedDates.applicationDate && (
        <li>
          <strong>{content['enrollment-alert-application-date-label']}</strong>{' '}
          {formattedDates.applicationDate}
        </li>
      )}

      {showEnrolledDetails && (
        <>
          {formattedDates.enrollmentDate && (
            <li>
              <strong>{content['enrollment-alert-enrolled-date-label']}</strong>{' '}
              {formattedDates.enrollmentDate}
            </li>
          )}

          {!!facilityName && (
            <li>
              <strong>{content['enrollment-alert-facility-label']}</strong>{' '}
              {facilityName}
            </li>
          )}
        </>
      )}
    </ul>
  );
};

export default WarningStatus;
